<template>
    <div class="hidden md:block">
        <inertia-link class="hover:text-gray-200"
                      :class="(!uris.length) ? 'font-semibold' : ''"
                      :href="route('accueil')">{{ __('Accueil') }}</inertia-link>
        <template v-if="uris" v-for="(uri, key) in uris">
                / <inertia-link class="hover:text-gray-200"
                                :class="(key == uris.length - 1) ? 'font-semibold' : ''"
                                :href="route('accueil')+genererBreadcrumb(key)">{{ __(uri) }}</inertia-link>
        </template>
    </div>
</template>

<script>
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    name: "Breadcrumb",
    data() {
        if(usePage().props.value.metas) {
            return {
                uris: computed(() => usePage().props.value.metas.breadcrumb),
            }
        } else {
            return {
                uris: computed(() => []),
            }
        }
    },
    methods: {
        genererBreadcrumb(niveau) {
            let breadcrumb = '';
            for(let i = 0; i <= niveau; i++)
                breadcrumb += '/'+this.uris[i];

            return breadcrumb;
        }
    },
    mounted() {
        //
    }
}
</script>

<style scoped>

</style>
